import React from "react";

export const getMedicineIconBoxClassName = (prescriptionRequired = false) =>
  prescriptionRequired
    ? "bg-[#FFF7ED] border border-[#FDE6D2]"
    : "bg-[#F1F4F9] border border-transparent";

export const renderMedicineTypeIcon = (
  typeOfSell = "",
  { prescriptionRequired = false } = {}
) => {
  if (prescriptionRequired) {
    return (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <rect
          x="4"
          y="9"
          width="16"
          height="6"
          rx="3"
          stroke="#B87333"
          strokeWidth="1.5"
        />
        <path
          d="M12 9v6"
          stroke="#B87333"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      </svg>
    );
  }

  const type = (typeOfSell || "").toLowerCase();
  const isSyrup =
    type.includes("syrup") ||
    type.includes("bottle") ||
    type.includes("ml") ||
    type.includes("infusion") ||
    type.includes("suspension") ||
    type.includes("liquid") ||
    type.includes("drops");
  const isTablet =
    type.includes("tablet") ||
    type.includes("pill") ||
    type.includes("caplet") ||
    type.includes("capsule") ||
    type.includes("strip");

  if (isSyrup) {
    return (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path
          d="M9 3h6v2.5l1.5 3V19a3 3 0 01-3 3h-3a3 3 0 01-3-3V8.5L9 5.5V3z"
          stroke="#0D6B6E"
          strokeWidth="1.5"
          strokeLinejoin="round"
        />
        <path
          d="M12 11v4M10.5 13h3"
          stroke="#0D6B6E"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      </svg>
    );
  }

  if (isTablet) {
    return (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <rect
          x="4"
          y="9"
          width="16"
          height="6"
          rx="3"
          stroke="#E85D75"
          strokeWidth="1.5"
        />
        <path d="M12 9v6" stroke="#E85D75" strokeWidth="1.5" strokeLinecap="round" />
      </svg>
    );
  }

  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <circle cx="10" cy="12" r="5.5" stroke="#4A90D9" strokeWidth="1.5" />
      <circle cx="14" cy="12" r="5.5" stroke="#E85D75" strokeWidth="1.5" />
    </svg>
  );
};
